import { User } from "../@core/data/users";

export class History {
  id?: string;
  customerId?: string;
  fullName?: string;
  dobYear?: number;

  issueDate?: Date;
  status?: string;
  value?: number;
  description?: string;
  imagesUrl?: string[]; //images

  shopId?: string;
  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}
